var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChecked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 240.5,
    height: 241.5,
    viewBox: "0 0 240.5 241.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#28ca56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03a62c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "alert_payment_successful",
    transform: "translate(-0.087 0.25)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval_Copy_2",
    "data-name": "Oval Copy 2",
    cx: 62,
    cy: 62,
    r: 62,
    transform: "translate(58.337 58)",
    fill: "none",
    stroke: "#03a62c",
    strokeWidth: 0.5,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_Copy_3",
    "data-name": "Oval Copy 3",
    cx: 83,
    cy: 82.5,
    rx: 83,
    ry: 82.5,
    transform: "translate(37.337 38)",
    fill: "none",
    stroke: "#03a62c",
    strokeWidth: 0.5,
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_Copy_4",
    "data-name": "Oval Copy 4",
    cx: 120,
    cy: 120.5,
    rx: 120,
    ry: 120.5,
    transform: "translate(0.337 0)",
    fill: "none",
    stroke: "#03a62c",
    strokeWidth: 0.5,
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("g", {
    id: "payment_successful_big",
    transform: "translate(68.764 68.764)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 52,
    cy: 51.5,
    rx: 52,
    ry: 51.5,
    transform: "translate(-0.427 0.236)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M16.577,34.382,0,17.852l4.642-4.628,11.935,11.9L41.774,0l4.642,4.628L16.577,34.382Z",
    transform: "translate(29.225 34.382)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/Checked.ddb9e6acb02267032c9757272eb6daef.svg";
export { ForwardRef as ReactComponent };